import { format } from "date-fns";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SuccessImage from "../../assets/t-successfull.png";
import CreateVoucherInputs from "../../Components/CreateVoucherAndCouponsInputs/CreateVoucherInputs";
import Modals from "../../Components/CreateVoucherCouponModal/CreateVoucherCouponModal";
import ProductModal from "../../Components/CreateVoucherCouponModal/ProductModal";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { FroalaTextEditor } from "../../Components/FroalaEditor/FroalaTextEditor";
import { stripHTML } from "../../Components/FroalaEditor/StripHtml";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { CreateVoucherApi } from "../../Utils/Api/CreateVoucherApi";
import { constant } from "../../Utils/Constant";
import { ErrorMessage } from "../../Utils/ErrorMsg/ErrorMsg";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { getUser, userId } from "../../Utils/LocalStorage";
import Navigation from "../Navigation/Navigation";
import "./CreateVoucher.css";
import getCroppedImg from "./cropImage";

const CreateVouchers = () => {
  const max_character_count = 1000;
  const [imageSrc, setImageSrc] = useState("");
  const [inputtnc, setInputtnc] = useState("");
  const [addtnc, setAddtnc] = useState([]);
  const [tnc, setTnc] = useState([]);
  const [list, setList] = useState([]);
  const [startDat, setStartDat] = useState(new Date());
  const [endDat, setEndDat] = useState(new Date());
  const [availableDat, setAvailableDat] = useState(new Date());
  const [dat, setDat] = useState("");
  const [isbaseImage, setIsBaseImage] = useState(false);
  const [description, setDescription] = useState("");
  const [errorLabelDesc, setErrorLabelDesc] = useState("");
  const [errorLabeltnc, setErrorLabeltnc] = useState("");
  const [errorLabelname, setErrorLabelname] = useState("");
  const [errorLabelprice, setErrorLabelprice] = useState("");
  const [errorLabelcheck, setErrorLabelcheck] = useState("");
  const [errorLabellimit, setErrorLabellimit] = useState("");
  const [errorLabelvalue, setErrorLabelvalue] = useState("");
  const [errorLabelstart, setErrorLabelstart] = useState("");
  const [errorLabelend, setErrorLabelend] = useState("");
  const [errorLabelAvailableDate, setErrorLabelAvailableDate] = useState("");
  const [errorImage, setErrorImage] = useState("");
  const [errorLogoImage, setErrorLogoImage] = useState("");
  const [errorFbImage, setErrorFbImage] = useState("");
  const [croppedImage, setCroppedImage] = useState("");
  const [logoImage, setLogoImage] = useState(null);
  const [fbImage, setFbImage] = useState(null);

  //image crop
  const uploadedImage = useRef(null);
  const imageUploader = useRef(null);

  const [show, setShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // const [croppedImage, setCroppedImage] = useState(defaultupload);
  const [uploadImgurl, setuploadImgurl] = useState("");
  const [imageType, setImageType] = useState("");

  // loading
  const [loading, setLoading] = useState(false);

  // upload-banner-img
  const [prevImg, setPrevimg] = useState("");
  const [cropImgBanner, setcropImgBanner] = useState("");
  const [bannerImageFlag, setbannerImageFlag] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isPreviewDisabled, setIsPreviewDisabled] = useState(true);
  const [productModalShow, setProductModalShow] = useState(false);
  const [dataApihandler, setDataApihandler] = useState("");
  const uid = parseInt(userId());

  const handleModelChange = (model) => {
    setDescription(model);
  };

  // terms&Conditions
  const handleCheck1 = (event) => {
    let temp = event.target.value;
    setTnc((tnc) => [...tnc, temp]);
  };

  const handleCheck = (e, key) => {
    const { checked } = e.target;
    setTnc([...tnc, list[key]]);
    if (!checked) {
      setTnc(tnc.filter((item) => item != list[key]));
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    setInputtnc(event.target.value);
    if (event.target.value.length == 0) {
      setErrorLabeltnc("Please enter a valid terms and conditions!");
    } else {
      setErrorLabeltnc("");
    }
  };

  const handleAdd = () => {
    if (inputtnc.length == 0) {
      setErrorLabeltnc("Please enter a valid terms and conditions!");
    } else {
      if (list.includes(inputtnc)) {
        setErrorLabeltnc("This Terms and Conditions already exists.");
      } else {
        setAddtnc((addtnc) => [...addtnc, inputtnc]);
        setErrorLabeltnc("");
      }
      setInputtnc("");
    }
  };

  const getChildData = (data, startDate, endDate, availableDate) => {
    setStartDat(startDate);
    setEndDat(endDate);
    setAvailableDat(availableDate);
    setDat(data);
  };

  const handleTncApi = async () => {
    const data = {
      api_method: "get",
    };
    const tncList = await CreateVoucherApi(data, () => {
      navigate("/");
    });
    if (tncList.status === 429) {
      setLoading(true);
      toast.error(tncList.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    let list = tncList.tnc.concat(addtnc);
    setList(list);
  };

  const numbersOnly = (str, flag) => {
    const regexDeci = /^(0|[1-9]\d*)(\.\d+)?$/;
    const regexNum = /^[0-9]+$/;
    if (flag === "actualprice") {
      return regexDeci.test(str);
    } else if (flag === "discountprice") {
      return regexDeci.test(str);
    } else if (flag === "limit") {
      return regexNum.test(str);
    }
  };

  const Bu_data = getUser();

  const handleSubmit = (e, type) => {
    e.preventDefault();

    let flag = false;
    const plainText = stripHTML(description);
    const currentCharCount = plainText.length;
    const hasInvalidTags = /<img|<figure/i.test(description);
    if (!description) {
      setErrorLabelDesc("Please provide some description!");
      flag = true;
    } else if (
      hasInvalidTags &&
      currentCharCount > max_character_count
    ) {
      setErrorLabelDesc(`Character limit exceeded! You can only enter up to ${max_character_count} characters, and images are not allowed.`);
      flag = true;
    } else if (hasInvalidTags) {
      setErrorLabelDesc(ErrorMessage.ImageError);
      flag = true;
    } else if (currentCharCount > max_character_count) {
      setErrorLabelDesc(`Character limit exceeded! You can only enter up to ${max_character_count} characters.`);
      flag = true;
    } else {
      setErrorLabelDesc("");
      flag = false;
    }

    if (dat.voucher_name == "") {
      setErrorLabelname("Please enter voucher name!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelname("");
    }

    if (dat.voucher_limit.length === 0) {
      setErrorLabellimit("Please enter voucher limit!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (dat.voucher_limit === 0) {
      setErrorLabellimit("Voucher limit cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.voucher_limit, "limit") === false) {
      setErrorLabellimit("Please enter valid limit!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabellimit("");
    }

    if (dat.voucher_price === "") {
      setErrorLabelprice("Please enter the discounted price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseInt(dat.voucher_price) === 0) {
      setErrorLabelprice("Voucher discounted price cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.voucher_price, "actualprice") === false) {
      setErrorLabelprice("Please enter valid discounted price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseFloat(dat.voucher_value) < parseFloat(dat.voucher_price)) {
      setErrorLabelprice(
        "Discounted value must be lesser than the Retail Value!"
      );
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelprice("");
    }

    if (dat.voucher_value == "") {
      setErrorLabelvalue("Please enter the retail price!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (parseInt(dat.voucher_value) === 0) {
      setErrorLabelvalue("Voucher retail value cannot be zero!");
      window.scrollTo(0, 0);
      flag = true;
    } else if (numbersOnly(dat.voucher_value, "discountprice") === false) {
      setErrorLabelvalue("Please enter valid retail price!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelvalue("");
    }

    if (!startDat) {
      setErrorLabelstart("Please enter start date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelstart("");
    }

    if (!endDat) {
      setErrorLabelend("Please enter expiration date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelend("");
    }
    if (!availableDat) {
      setErrorLabelAvailableDate("Please enter available until date!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLabelAvailableDate("");
    }

    if (tnc.length === 0) {
      setErrorLabeltnc("Please select at least one terms & condition!");
      flag = true;
    } else {
      setErrorLabeltnc("");
    }

    if (!logoImage) {
      setErrorLogoImage("Please upload voucher image!");
      window.scrollTo(0, 0);
      flag = true;
    } else {
      setErrorLogoImage("");
    }
    // var imgPath;
    // if (!isbaseImage) {
    //   imgPath = cropImgBanner.split("/").slice(3).join("/");
    // }
    if (flag === false) {
      const dataApi = {
        api_method: "post",
        voucher_name: dat.voucher_name,
        business_id: parseInt(uid),
        category_id: Bu_data.category_id,
        voucher_limit: dat.voucher_limit,
        voucher_value: parseFloat(dat.voucher_value),
        voucher_price: parseFloat(dat.voucher_price),
        expiry_start_date: format(startDat, "yyyy-MM-dd"),
        expiry_end_date: format(endDat, "yyyy-MM-dd"),
        voucher_avail_until_date: format(availableDat, "yyyy-MM-dd"),
        description: description,
        city_id: Bu_data.city_id,
        is_image_changed: true,
        image_path: {
          data: logoImage,
          file_type: "png",
        },
        is_social_image: fbImage == null ? false : true,
        voucher_social_image_path: {
          data: fbImage,
          file_type: "png",
        },
        tnc: tnc,
      };
      if (type === "preview") {
        setProductModalShow(true);
      } else if (type === "save") {
        setDataApihandler(dataApi);
        setModalShow(true);
      }
    }
  };

  const navigate = useNavigate();

  const handleCreate = async (data) => {
    setLoading(true);
    const res = await CreateVoucherApi(data, () => {
      navigate("/");
    });
    setLoading(false);

    if (res === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      if (res.success === true) {
        toast.success("Voucher successfully created", {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        // setErrorLabelapi("Voucher successfully created");
        navigate("/my-account/manage-vouchers");
      } else if (res.status === 429) {
        setLoading(false);
        toast.error(res.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(res.message, {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  useEffect(() => {
    handleTncApi();
  }, [addtnc]);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      // setIsBaseImage(true);
      setcropImgBanner(croppedImage);

      let typeImg = croppedImage.split("/");
      let imageTypeSplit = typeImg[1].split(";");

      setImageType(imageTypeSplit[0]);
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onClose = useCallback(() => {
    setCroppedImage(null);
  }, []);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const uploadFiles = () => {
    document.getElementById("selectFile").click();
  };

  // upload-banner-img
  const inputRef = useRef(null);
  const triggerFileSelectPopup = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  // const handleSetCropperImg = (e) => {
  //   setShow(true);
  //   setPrevimg(URL.createObjectURL(e.target.files[0]));
  // };

  useEffect(() => {
    if (
      dat.voucher_name !== "" &&
      cropImgBanner !== "" &&
      startDat !== null &&
      availableDat !== null &&
      endDat !== null &&
      dat?.voucher_limit > 0 &&
      dat?.voucher_value !== "" &&
      dat?.voucher_price !== "" &&
      description !== "" &&
      tnc.length > 0
    ) {
      setIsPreviewDisabled(false);
    } else {
      setIsPreviewDisabled(true);
    }
  }, [
    dat.voucher_name,
    cropImgBanner,
    startDat,
    availableDat,
    endDat,
    dat?.voucher_limit,
    dat?.voucher_value,
    dat?.voucher_price,
    description,
    tnc,
  ]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/my-account/manage-vouchers"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <p className="page-maintitle">Create Voucher</p>
          <div className="acc-dashboard mt-4">
            <CreateVoucherInputs
              func={getChildData}
              errorLabelname={errorLabelname}
              errorLabellimit={errorLabellimit}
              errorLabelprice={errorLabelprice}
              errorLabelvalue={errorLabelvalue}
              errorLabelstart={errorLabelstart}
              errorLabelend={errorLabelend}
              errorLabelAvailableDate={errorLabelAvailableDate}
              setErrorLabelname={setErrorLabelname}
              setErrorLabelstart={setErrorLabelstart}
              setErrorLabelend={setErrorLabelend}
              setErrorLabelAvailableDate={setErrorLabelAvailableDate}
              errorLabelcheck={errorLabelcheck}
              errorLogoImage={errorLogoImage}
              setErrorLogoImage={setErrorLogoImage}
              errorFbImage={errorFbImage}
              setErrorFbImage={setErrorFbImage}
              croppedImage={croppedImage}
              setCroppedImage={setCroppedImage}
              setLogoImage={setLogoImage}
              setFbImage={setFbImage}
              logoImage={logoImage}
              fbImage={fbImage}
            />
            <Row className="mx-2 desc_terms_condition create_Voucher_Desc_Row mb-3">
              <Col md="12" className="px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom info-sec">
                    Voucher Description <span className="star-required">*</span>{" "}
                    <p className="info-text-space-f13">
                      &#40;To start from a new line, please press Shift +
                      Enter.&#41;
                    </p>
                  </Form.Label>
                  <FroalaTextEditor
                    description={description}
                    setDescription={setDescription}
                    max_character_count={max_character_count}
                  />
                  <ErrorLabel ErrorDisplay={errorLabelDesc} />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mx-2 desc_terms_condition">
              <Col md="12" className="px-2">
                <Form.Group className="mb-0" controlId="formBasicEmail">
                  <Form.Label className="form-label-custom">
                    Terms & Conditions <span className="star-required">*</span>
                    <span className="span-italic">
                      You can select terms & conditions listed below or you can
                      add more.
                    </span>
                  </Form.Label>
                  <InputGroup className="edit-border">
                    <Form.Group
                      className="mb-3 ack term-sec"
                      controlId="formBasicCheckbox"
                    >
                      {list
                        ? list.map((item, key) => {
                            return (
                              <div className="Custom-T-C-list">
                                {/* <Form.Check
                                  type="checkbox"
                                  value={item}
                                  label={item}
                                  onChange={(e)=>handleCheck(e,key)}
                                  checked={tnc.includes(item)}
                                /> */}

                                <label
                                  for={item}
                                  value={item}
                                  className="form-check-label"
                                  style={{ display: "flex", gap: 10 }}
                                >
                                  <input
                                    type="checkbox"
                                    id={item}
                                    className="form-check-input form-check ack"
                                    style={{ border: "1px solid #e66100" }}
                                    onChange={(e) => handleCheck(e, key)}
                                    checked={tnc.includes(item)}
                                  />
                                  {item}
                                </label>
                              </div>
                            );
                          })
                        : " "}

                      <InputGroup
                        className="search-bar add-bar tcAdd"
                        onChange={handleChange}
                      >
                        <Form.Control
                          maxLength={200}
                          placeholder="Add More"
                          className="addmor"
                          value={inputtnc}
                          autoComplete="off"
                        />
                        <Button variant="outline-secondary" onClick={handleAdd}>
                          + Add
                        </Button>
                      </InputGroup>
                      <ErrorLabel ErrorDisplay={errorLabeltnc} />
                    </Form.Group>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <div className="text-center small-btns d-flex my-4">
                <button
                  className="green-btn"
                  onClick={(e) => handleSubmit(e, "preview")}
                >
                  Preview
                </button>
              </div>
              <div className="text-center small-btns d-flex">
                <Link to="/my-account/manage-vouchers">
                  <p className="view">Cancel</p>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                  onClick={(e) => handleSubmit(e, "save")}
                >
                  Save
                </Button>
              </div>
            </Row>
          </div>
        </div>
      </div>
      <Modals
        className="Modal_Popup"
        show={modalShow}
        onHide={() => setModalShow(false)}
        images={SuccessImage}
        description={
          <>
            Your voucher is almost ready! Click "Yes" to finish creating, but
            remember, once created you cannot delete the voucher but can always
            disable it whenever you want. This will not affect the customers who
            might have already purchased the voucher, they can still redeem it.
          </>
        }
        firstbutton="No"
        secondbutton="Yes"
        saveButtonfuc={handleCreate}
        Apidata={dataApihandler}
      />
      <ProductModal
        className="Modal_Popup"
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        flag="Voucher"
        product_name={dat.voucher_name}
        product_image={logoImage}
        availableDat={availableDat}
        endDat={endDat}
        product_value={parseFloat(dat.voucher_value)}
        product_price={parseFloat(dat.voucher_price)}
        description={description}
        tnc={tnc}
      />
      <PrivacyTermsConditions />
    </>
  );
};

export default CreateVouchers;
